import querystring from 'querystring';
import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router';
import playBtn from 'assets/img/play-btn.png';
import { VideoPopup } from 'swag-client-common/components/video-popup';
import { removeAllQueries } from 'swag-client-common/utils/react-router-query.utils';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import css from './what-we-do-video.scss';
const WhatWeDoVideoComponent = ({
  openVideoPopup,
  location
}) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const buttonRef = useRef(null);
  useEffect(() => {
    const searchQuery = location.search.replace('?', '');
    const isVideoModalOpenQuery = !!querystring.parse(searchQuery).isVideoModalOpen;
    setIsVideoModalOpen(isVideoModalOpenQuery);
  }, []);
  useEffect(() => {
    if (isVideoModalOpen) {
      openVideoPopup();
      removeAllQueries();
    }
  }, [isVideoModalOpen]);
  const handlePlayClick = () => {
    setIsVideoModalOpen(false);
    openVideoPopup();
  };
  const handleClosePopup = () => {
    var _buttonRef$current;
    (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
  };
  return /*#__PURE__*/React.createElement("section", {
    className: css.whatWeDoVideoWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css.playSection
  }, /*#__PURE__*/React.createElement("div", {
    ref: buttonRef,
    className: css.clickableArea,
    onClick: handlePlayClick,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, handlePlayClick)
  }, /*#__PURE__*/React.createElement("img", {
    src: playBtn,
    alt: "Play button icon",
    className: css.playVideoImg
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: css.bigText
  }, "What we do"), /*#__PURE__*/React.createElement("h4", {
    className: css.text
  }, "60 seconds")))), /*#__PURE__*/React.createElement(VideoPopup, {
    playedFromUrl: isVideoModalOpen,
    closeCallback: handleClosePopup
  }));
};
export const WhatWeDoVideo = withRouter(WhatWeDoVideoComponent);